export default {
  hasPendingProposals: false,
  showProposalsMenuItem: false,
};
